// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt

if(!window.accu360) window.accu360 = {};

// Add / update a new Lead / Communication
// subject, sender, description
daffy.send_message = function(opts, btn) {
	return daffy.call({
		type: "POST",
		method: "accu360.templates.utils.send_message",
		btn: btn,
		args: opts,
		callback: opts.callback
	});
};

accu360.subscribe_to_newsletter = function(opts, btn) {
	return daffy.call({
		type: "POST",
		method: "daffy.email.doctype.newsletter.newsletter.subscribe",
		btn: btn,
		args: {"email": opts.email},
		callback: opts.callback
	});
}

// for backward compatibility
accu360.send_message = daffy.send_message;
